import React, {
  useContext, useRef, useEffect
} from 'react';
import { useTranslation } from 'react-i18next';
import { Package } from './PackageBlock';
import { PackageActive } from './PackageActive';
import { useAxios } from '../../../../hooks/useAxios';
import { Balance } from '../Balance';
import { getTariffsPath, getInvoicesByScopesPath } from '../../routes';
import { PaymentModal } from '../PaymentModal';
import { Invoices } from '../Invoices';
import { InvoicesAppContext } from '../../context';
import { useOnScreen } from '../../../../hooks/useOnScreen';
import { PackagesUnpaid } from './PackagesUnpaid';

export const Packages = () => {
  const { t } = useTranslation();
  const {
    isMobileSite, setHasErrors, setPackageTariffs
  } = useContext(InvoicesAppContext);
  const ref = useRef();
  const isVisible = useOnScreen(ref);

  const { response: tariffs } = useAxios({
    method: 'get',
    url: getTariffsPath,
    isInitialCall: true,
    onError: () => setHasErrors(true)
  });

  const { response: responseInvoices } = useAxios({
    method: 'get',
    url: getInvoicesByScopesPath('active'),
    isInitialCall: true,
    onError: () => setHasErrors(true)
  });

  useEffect(() => {
    setPackageTariffs(tariffs);
  }, [isVisible, tariffs]);

  const invoicesExpireTime = responseInvoices?.map(
    element => new Date(element?.deal?.expires_at).getTime()
  );

  return (
    <>
      {isMobileSite && <PackagesUnpaid />}
      <div className="packages">
        <div className="packages-active">
          <p>{t('packages.title')}</p>
          { responseInvoices?.length ? responseInvoices?.map(invoice => (
            <PackageActive
              key={invoice.id}
              invoice={invoice}
            />
          )) : (
            <div className="packages-empty">
              {t('packages.no_packages')}
            </div>
          )}
        </div>
        <div className="packages-list">
          <p>{t('packages.new')}</p>
          <div className="packages-list__items">
            { tariffs?.map(tariff => (
              <Package
                key={tariff.name}
                name={tariff.name}
                price={tariff.price}
                count={tariff.paid_ads_count}
                promotions={tariff.promotions}
                wallet_amount={tariff.wallet_amount}
                expired={invoicesExpireTime}
              />
            ))}
          </div>
        </div>
      </div>
      { isMobileSite && (
        <>
          <Balance />
          <Invoices />
          <PaymentModal />
        </>
      )}
    </>
  );
};
